import { createFileRoute } from '@tanstack/react-router'
import { GlossaryPage, glossaryHead } from '@/components/glossary-page'

const data = {
  term: 'Real User Monitoring (RUM)',
  slug: 'real-user-monitoring',
  definition: `Real user monitoring collects performance and availability data from actual user sessions. A small script embedded in your frontend records metrics like page load time, time to interactive, and errors encountered by real visitors.

Unlike synthetic monitoring, RUM data reflects the true user experience. It captures the impact of different devices, browsers, network conditions, and geographic locations that synthetic tests cannot fully replicate.

RUM is especially valuable for frontend performance optimization. It shows you which pages are slow for real users, which browsers cause the most errors, and how performance varies by region.`,
  whyItMatters: `Synthetic monitoring tells you whether your service is up. RUM tells you what your users are actually experiencing. A service can pass every synthetic check while still delivering a poor experience to users on slow connections or older devices.

RUM data also helps prioritize performance improvements. Instead of guessing which pages need optimization, you can see exactly where users experience the most friction.`,
  howUptrackHelps: `Uptrack focuses on synthetic monitoring, which complements RUM tools. While RUM tells you about the frontend experience, Uptrack ensures your backend endpoints and APIs are available and responding quickly.

Together, Uptrack and a RUM tool give you complete visibility — Uptrack watches your infrastructure 24/7 (even when no users are online), while RUM captures the nuances of real user sessions.`,
  relatedTerms: [
    { name: 'Synthetic Monitoring', href: '/glossary/synthetic-monitoring' },
    { name: 'Latency', href: '/glossary/latency' },
    { name: 'Uptime', href: '/glossary/uptime' },
    { name: 'MTTD', href: '/glossary/mttd' },
  ],
}

export const Route = createFileRoute('/_site/glossary/real-user-monitoring')({
  component: () => <GlossaryPage data={data} />,
  head: () => glossaryHead(data),
})
